export enum SensorTabType {
  SENSORS = "sensors",
  GATEWAYS = "gateways",
}

export const sensorTabMapToIndex: Record<SensorTabType, number> = {
  [SensorTabType.SENSORS]: 0,
  [SensorTabType.GATEWAYS]: 1,
};

export const sensorTabToDisplayName: Record<SensorTabType, string> = {
  [SensorTabType.SENSORS]: "Sensors",
  [SensorTabType.GATEWAYS]: "Gateways",
};

export const sensorTabList: SensorTabType[] = Object.keys(
  sensorTabMapToIndex
) as SensorTabType[];

export const getTabIndex = (tabType: SensorTabType): number => {
  return sensorTabMapToIndex[tabType];
};
const sensorIndexToTab = () => {
  const remappedEntries = Object.entries(sensorTabMapToIndex).map(
    ([key, value]) => [value, key]
  );

  return Object.fromEntries(remappedEntries);
};

export const SensorIndexToTab: Record<number, SensorTabType> =
  sensorIndexToTab();
